/*
 * File: cell-translation-job-user.ts
 * Created: 2026-02-05
 * Author: Val Liu
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellTranslationJobUser extends BaseTableBodyCell {
    get userName(): string {
        const user = this.row?.user ?? null;
        const name = String(user?.name ?? "").trim();
        const email = String(user?.email ?? "").trim();
        return name || email || "-";
    }

    get orgName(): string {
        const org = this.row?.organization ?? null;
        const name = String(org?.name ?? "").trim();
        return name ? this.$_(name) : "-";
    }
}
